import toast from "react-hot-toast";

const server = process.env.REACT_APP_SERVER_URL || "";
export const reservation = {
  repayment: async (id: any) => {
    try {
      const response = await fetch(`${server}/api/reservation/stripe-repayment/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
      });
      const data = await response.json();
      return data.sessionUrl;
    } catch (error) {
      console.error("Error in repayment:", error);
      throw error;
    }
  },
  getReservationByLocations: async (id: any) => {
    const response = await fetch(`${server}/api/reservation/location/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });
    return response.json();
  },
  fetchAdminCanceledReservationByClient: async (pageNumber: number) => {
    const response = await fetch(`${server}/api/reservation/get-canceled?page=${pageNumber}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });
    return response.json();
  },
  payRefundReservation: async (ref: any) => {
    const response = await fetch(`${server}/api/reservation/refund/${ref}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });
    return response.json();
  },
  payPartialRefundReservation: async (ref: any) => {
    const response = await fetch(`${server}/api/reservation/partial-refund/${ref}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });
    return response.json();
  },
  getReservations: async (pageNumber: number) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await fetch(`${server}/api/reservation?page=${pageNumber}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        TimeZone: timeZone,
      },
    });
    return response.json();
  },

  getReservationsToPay: async (pageNumber: number) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response = await fetch(`${server}/api/reservation/to-pay?page=${pageNumber}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        TimeZone: timeZone,
      },
    });
    return response.json();
  },

  getOwnerAllTransferts: async (pageNumber: number) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response = await fetch(`${server}/api/reservation/owner-transferts?page=${pageNumber}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        TimeZone: timeZone,
      },
    });

    return response.json();
  },

  getOwnerReservationBalance: async () => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response = await fetch(`${server}/api/reservation/totalAmount`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        TimeZone: timeZone,
      },
    });

    return response.json();
  },

  getOwnerAllTransfertsGain: async (pageNumber: number) => {
    const response = await fetch(`${server}/api/reservation/owner-transferts-gain?page=${pageNumber}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });

    return response.json();
  },

  getTentativeReservations: async (page: number, reference: string) => {
    const response = await fetch(
      `${server}/api/admin/reservations/tentative?page=${page}&reference=${reference}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
      }
    );

    return response.json();
  },
  sendCancelEmail: async (formData: any) => {
    try {
      const response = await fetch(`${server}/api/reservation/canceled`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        const data = await response.json();
        return data;
      } else {
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },
  update: async (data: any, id: any) => {
    const result = await fetch(`${server}/api/reservation/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
      body: JSON.stringify(data),
    });
    return result.json();
  },
  confirm: async (data: any, id: any) => {
    try {
      const response = await fetch(`${server}/api/reservation/confirmed/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success(result.msg || "Action effectuée avec succès !");
      } else {
        toast.error(result.error || "Une erreur est survenue.");
      }

      return result;
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Erreur de connexion au serveur.");
      throw error;
    }
  },
  checkReservationByReference: async (ref: any) => {
    const response = await fetch(`${server}/api/reservation/testpay/${ref}`);
    return response.json();
  },
  payReservationOwner: async (ref: any) => {
    const response = await fetch(`${server}/api/reservation/pay-owner/${ref}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });
    return response.json();
  },
  getAvailableHours: async (id: any, selectedDay: any, type: string) => {
    const response = await fetch(`${server}/api/reservation/free-hours/${id}/${selectedDay}?type=${type}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  },

  getFullyBookedDays: async (id: any, type: string) => {
    const response = await fetch(`${server}/api/reservation/fully-days/${id}?type=${type}`);
    return response.json();
  },

  getFullBookedDays: async (id: any) => {
    const response = await fetch(`${server}/api/reservation/full-days/${id}`);
    return response.json();
  },
  getReservationById: async (id: any) => {
    const response = await fetch(`${server}/api/reservation/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });
    return response.json();
  },
  getReservationByClient: async (id: any, page: any) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await fetch(`${server}/api/reservation/client/${id}?page=${page}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        TimeZone: timeZone,
      },
    });
    return response.json();
  },
  getTerminatedReservationByClient: async (id: any) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response = await fetch(`${server}/api/reservation/terminated-reservation/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        TimeZone: timeZone,
      },
    });
    return response.json();
  },
  getReservationByOwner: async (id: any, page: any) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response = await fetch(`${server}/api/reservation/owner/${id}?page=${page}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        TimeZone: timeZone,
      },
    });
    return response.json();
  },

  getUserReservationInvoice: async (page = 1, searchTerm = "") => {
    const query = new URLSearchParams({ page: page.toString() });
    if (searchTerm) {
      query.append("searchTerm", searchTerm);
    }

    const result = await fetch(`${server}/api/invoices?${query.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });

    return result.json();
  },

  getReservationByOwnerAsClient: async (id: any, page: any) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await fetch(`${server}/api/reservation/client/${id}?page=${page}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        TimeZone: timeZone,
      },
    });
    return response.json();
  },
  fetchAdminCanceledReservationByOwner: async (pageNumber: number) => {
    const response = await fetch(`${server}/api/reservation/pending?page=${pageNumber}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });
    return response.json();
  },

  getEnAttenteReservation: async (pageNumber: number) => {
    const response = await fetch(`${server}/api/reservation/list-en-attente?page=${pageNumber}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });
    return response.json();
  },

  getPendingOwnerReservation: async (id: any, page: any) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response = await fetch(`${server}/api/reservation/pending-owner/${id}?page=${page}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        TimeZone: timeZone,
      },
    });
    return response.json();
  },
  getBlockedReservationByOwner: async (id: any) => {
    const response = await fetch(`${server}/api/reservation/owner-blocked/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });
    return response.json();
  },
  fetchSubscriptionDetails: async (id: any) => {
    const response = await fetch(`${server}/api/subscription/confirmed/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });
    return response.json();
  },
  deleteReservation: async (id: any) => {
    const response = await fetch(`${server}/api/admin/reservation/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "An error occurred while deleting rule .");
    }
    const res = await response.json();
    toast.success(res.message);
  },
  catch(error: any) {
    console.error("error", error);
    if (error instanceof Error) {
      toast.error(error.message);
    } else {
      toast.error("An unexpected error occurred.");
    }
    throw new Error("Error deleting rule.");
  },

  payReservation: async (formData: any) => {
    try {
      const response = await fetch(`${server}/api/reservation/stripe-payment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        const data = await response.json();
        return data.sessionUrl;
      } else {
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },

  paySubscription: async (formData: any) => {
    try {
      const response = await fetch(`${server}/api/subscription/stripe-payment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        const data = await response.json();
        return data.sessionUrl;
      } else {
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },
  checkReservation: async (formData: any) => {
    try {
      const response = await fetch(`${server}/api/reservation/exist`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        const data = await response.json();
        return data;
      } else {
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },
  makeReservationOwner: async (formData: any) => {
    try {
      const response = await fetch(`${server}/api/reservation/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        const data = await response.json();
        return data.sessionUrl;
      } else {
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },

  filterAllReservation: async (data: any) => {
    const result = await fetch(`${server}/api/reservation/search`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
      body: JSON.stringify(data),
    });
    return result.json();
  },
  transfertAmountOwner: async (amount: number, owner_id: string) => {
    const data = { amount, owner_id };
    const result = await fetch(`${server}/api/iban-transfers`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
      body: JSON.stringify(data),
    });
    return result.json();
  },

  sendReservationFeedback: async (data: any) => {
    const formData = new FormData();

    try {
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key) && key !== "images") {
          const value = data[key];
          if (value !== undefined && value !== null) {
            if (Array.isArray(value)) {
              formData.append(key, JSON.stringify(value));
            } else {
              formData.append(key, value);
            }
          }
        }
      }

      if (data.images instanceof File) {
        formData.append("images", data.images);
      }

      const response = await fetch(`${server}/api/reservation-feedbacks`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        toast.success(result.res);
        return result;
      } else {
        toast.error(result.error);
        throw new Error(result.error || "Submission failed");
      }
    } catch (error) {
      console.error("Error sending feedback:", error);
      throw error;
    }
  },

  adminGetAllFeedbacks: async (page: number, reference: string) => {
    const result = await fetch(`${server}/api/admin/reservation-feedbacks?page=${page}&reference=${reference}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });

    let response = await result.json();
    if (result.ok) {
      return response;
    } else {
      throw new Error(response.message);
    }
  },

  getAllFeedbacksByUserId: async (page: number, reference: string) => {
    const result = await fetch(`${server}/api/feedbacks?page=${page}&reference=${reference}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });

    let response = await result.json();
    if (result.ok) {
      return response;
    } else {
      throw new Error(response.message);
    }
  },

  deleteReservationFeedback: async (reference: string) => {
    try {
      const response = await fetch(`${server}/api/reservation-feedbacks/${reference}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "An error occurred while deleting rule .");
      }
      const res = await response.json();
      toast.success(res.msg);
    } catch (error) {
      console.error("error", error);
      // if (error instanceof Error) {
      //   toast.error(error.message);
      // } else {
      //   toast.error("An unexpected error occurred.");
      // }
      throw new Error("Error deleting rule.");
    }
  },
};
